import { defineStore } from "pinia"
import Plausible, { EventOptions, PlausibleOptions } from 'plausible-tracker'
import { ref } from "vue"

export type MyTracker = (eventName: string, options?: EventOptions, eventData?: PlausibleOptions) => void
const isDebug =  import.meta.env.VITE_PLAUSIBLE_DEBUG_DEV !== undefined ? import.meta.env.VITE_PLAUSIBLE_DEBUG_DEV === "true" : true
// export factory function
// console.log('isDebug', isDebug)
export const usePlausibleStore = defineStore('plausible', () => {
  // if (isDebug) {
  //   console.warn ('Plausible is in debug mode')
  // }
  const tracker = ref<MyTracker | undefined>()
  const domain = import.meta.env.VITE_PLAUSIBLE_URL || 'veuve-clicquot-finder-test-out'
  const { trackEvent, trackPageview } = Plausible({
    domain: domain,
    trackLocalhost: true,
  })
  const lastTimestamp = ref<number | null>(null)

  /************************/
  /*         SETUP        */
  /************************/

  tracker.value = (eventName: string, options?: EventOptions, eventData?: PlausibleOptions) => {
    // if (isDebug) {
    //   console.warn (eventName, options, eventData)
    //   return
    // }
    trackEvent(eventName, options, eventData)
  }

  trackPageview({ hashMode: true })

  /************************/
  /*       FUNCTIONS      */
  /************************/
  const setCurrentTime = () => {
    lastTimestamp.value = Math.floor(Date.now()/1000)
  }

  const getElapsedTime = () => {
    const currentTime = Date.now()/1000
    const elapsed = lastTimestamp.value ? Math.floor(currentTime - lastTimestamp.value) : 0
    // lastTimestamp.value = currentTime
    return elapsed
  }

  return { tracker, setCurrentTime, getElapsedTime }
})
